export type PartnerConfig = {
  slug: string;
  theme: {
    cssClass: string;
    replaceVytalLogo?: boolean;
    colors?: { primary: string; secondary: string };
  };
  i18n: { namespace: string };
  assets: { logo?: string; favicon?: string };
  links: { CTA?: string };
  currency: string;
};

// Used whenever a transaction has no partner with its own currency.
export const DEFAULT_CURRENCY = '€';

// Lowercase values
export enum PartnerSlug {
  HOI = 'hoi',
}

/**
 * Partner config registry, keyed by slug (lowercased).
 *
 * To add a partner:
 * 1. Add entry here.
 * 2. Create translation override at public/locales/{locale}/{slug}.json,
 *    keyed by target namespace: { "<namespace>": { "<key>": "<override>" } }.
 * 3. Add CSS class in styles/globals.css with CSS variable overrides.
 * 4. Set `currency`; override the amount strings in the partner bundle if the
 *    symbol goes before the amount (see hoi.json).
 */
const partnerConfigs: Record<string, PartnerConfig> = {
  [PartnerSlug.HOI]: {
    slug: PartnerSlug.HOI,
    theme: {
      cssClass: 'theme-hoi',
      replaceVytalLogo: true,
      colors: {
        primary: 'var(--hoi-blue)',
        secondary: 'var(--hoi-red)',
      },
    },
    i18n: { namespace: PartnerSlug.HOI },
    assets: {
      logo: '/img/hoi-logo.png',
      favicon: '/img/hoi-favicon.png',
    },
    links: { CTA: 'https://hoi-return.com' },
    currency: '$',
  },
};

export function getPartnerConfig(slug?: string | null): PartnerConfig | null {
  if (!slug) return null;
  return partnerConfigs[slug.toLowerCase()] ?? null;
}
